module.exports = __webpack_public_path__ + "images/banner-1-6372dca89ec5dcb8e52c3718e69db58b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Banner/banner-1.jpg
// module id = 22
// module chunks = 0